export const STAGES = [
  {
    name: "Discovery",
    desc: "We walk your space, study how your teams work and define a brief that fits the way you actually operate.",
    detail:
      "Our team spends time on your floors; measuring, photographing and interviewing department heads. We study headcounts, work patterns and growth plans so the design is grounded in how your company really functions, not in a template.",
    deliverables: ["Detailed project brief", "Space programme", "Budget alignment"],
  },
  {
    name: "Design & BOQ",
    desc: "Concept to detailed drawings with a line-by-line bill of quantities; every rupee visible before we begin.",
    detail:
      "Concepts, layouts and 3D views are presented stage by stage, with material boards you can touch. In parallel, we price every item in a line-by-line bill of quantities, so costs are agreed before work begins; never discovered mid-project.",
    deliverables: ["Design drawings", "3D visuals", "Itemised BOQ"],
  },
  {
    name: "Permits & Compliance",
    desc: "Every approval, NOC and statutory clearance secured before a single tool touches your site.",
    detail:
      "We prepare and submit every application your project needs; municipal, fire, environmental and society-level; and follow it through personally. You never stand in a queue or chase an inspector.",
    deliverables: ["All approvals in hand", "Compliance file", "Statutory sign-offs"],
  },
  {
    name: "Off-Site Preparation",
    desc: "Modular work and fabrication happen in controlled workshops; not on your live floor.",
    detail:
      "Joinery, metalwork, glazing and MEP modules are fabricated in our partner workshops while procurement is locked with our vendor network. Site work becomes assembly, which means less noise, less dust and dramatically fewer surprises.",
    deliverables: ["Approved samples & mock-ups", "Procurement locked", "Production-ready modules"],
  },
  {
    name: "On-Site Execution",
    desc: "One contract, one team on site; quality checked at every stage and reported straight to you.",
    detail:
      "Our own site engineers run every trade, with documented quality checks at each stage and a weekly report you can actually read; photographs, progress percentage and decisions needed from you, all in one place.",
    deliverables: ["Supervised site", "Stage-wise QC reports", "Live timeline tracking"],
  },
  {
    name: "Snagging & Sign-Off",
    desc: "We hunt down every snag, hand over complete as-built documentation and stay on for support.",
    detail:
      "We create the snag list with you, close every item, test and commission every service, and hand over complete as-built drawings and warranties. Our operations team remains available for support long after move-in day.",
    deliverables: ["Snag-free handover", "As-built documentation", "Ongoing support"],
  },
];
